var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalleryVr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gallery_vr",
    "data-name": "gallery vr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art",
    className: "themeSVGStroke themeSVGStrokeHover"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "themeable",
    id: "Rectangle_1677",
    "data-name": "Rectangle 1677",
    x: 3,
    y: 3,
    width: 22,
    height: 22,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    id: "Path_10577",
    "data-name": "Path 10577",
    d: "M9,29H29V9",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "VR",
    className: "themeSVGStroke themeSVGStrokeHover"
  }, /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    d: "M16.09,14.46h2.1a1.79,1.79,0,0,0,1.93-1.64h0v-.19a1.9,1.9,0,0,0-1.86-1.92H16.09V18",
    fill: "none",
    stroke: "#3c4347",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "themeable",
    points: "13.21 10 10.24 17.75 7.21 10",
    fill: "none",
    stroke: "#3c4347",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "themeable",
    x1: 18.31,
    y1: 14.58,
    x2: 20.47,
    y2: 17.75,
    fill: "none",
    stroke: "#3c4347",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678",
    "data-name": "Rectangle 1678",
    width: 32,
    height: 32,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryVr);
export default __webpack_public_path__ + "static/media/gallery_vr.67f2e5728d5357c6d9dd82953b57621c.svg";
export { ForwardRef as ReactComponent };